let FETCHFIGFYURL = "https://pcls1.craftyclicks.co.uk/json/rapidaddress";
let FETCHFYTOKEN = "d2e8d-0992e-47a3e-0938a";

const REGION = "eu-west-2";

let BASE_URL = "http://localhost:3200/";
let BUCKETNAME = "fiixitstaging";
let REACT_APP_STRIPE_PUBLISHABLE_KEY = "pk_test_51RtkJ7FhsHgKprAiEDpdBARUt7mbGQB3OrqgVCOgfhqP8KHBiPD7RpIttZqAssm2O3agtRlo0Ez6gfjAskEBCxK400T8StBBt0";
/** Optional override; if unset, FCM VAPID comes from `firebase.web.json` for the active Firebase env. */
let REACT_APP_FCM_VAPID_KEY = "BDRMd-4TrsAIf2FB9czf3a5-pYi-D0jEHvpgQ-n0mC-TghEfP6cpAXq2kf9yC52-mdHnlZQSBB5CQH2LKXUO--Q";
let REACT_APP_LANDLORD_DEMO_URL = "https://calendly.com";
// Public Turnstile site key — safe to expose client-side, pairs with the secret key server-side
let REACT_APP_TURNSTILE_SITE_KEY = "0x4AAAAAADxJybmq1VTnuZqa";
// Update based on environment
switch (process.env.REACT_APP_ENV) {
  case "development":
    BASE_URL = "http://localhost:3200/";
    REACT_APP_STRIPE_PUBLISHABLE_KEY = "pk_test_51RtkJ7FhsHgKprAiEDpdBARUt7mbGQB3OrqgVCOgfhqP8KHBiPD7RpIttZqAssm2O3agtRlo0Ez6gfjAskEBCxK400T8StBBt0";
    REACT_APP_FCM_VAPID_KEY = "BDRMd-4TrsAIf2FB9czf3a5-pYi-D0jEHvpgQ-n0mC-TghEfP6cpAXq2kf9yC52-mdHnlZQSBB5CQH2LKXUO--Q";
    break;
  case "staging":
    BASE_URL = "https://staging-data.fiixit.co.uk/";
    REACT_APP_STRIPE_PUBLISHABLE_KEY = "pk_test_51RsgttPATOi6b6lnqXSsMezyT18vzuk7EMxF3pgmbmgMHLhe2Q8wuLmSm6jjl0Ty63BdrR9wt8F04CduAghDamXh00gRLPnaQF";
    REACT_APP_FCM_VAPID_KEY = "BJdIC8uGbBc7RZkYpb1OuYzIK8d5IJA28OMc6oSuMuoSUTOhwSG8lNRjjDjMaMQ1A3wmzJLcnXSU5Xy2aL-ueRs";
    REACT_APP_LANDLORD_DEMO_URL = "https://calendly.com/taj-sohal/30min";
    REACT_APP_TURNSTILE_SITE_KEY = "0x4AAAAAADxSzrlQxJznE6sB";
    break;
  case "production":
    BASE_URL = "https://data.fiixit.co.uk/";
    BUCKETNAME = "fiixitprod";
    REACT_APP_STRIPE_PUBLISHABLE_KEY = "pk_live_51RsgtiAPtIGhtn4YeCCJlVvFST5PvI8K6ivStZGbkoMd2R96ObtVbRtzEF5p1ZFZ4p618cuIBjaGtEPoHqKTue3H00i34H7469";
    REACT_APP_FCM_VAPID_KEY = "BB1BMf8xd_GSwQc4LIaeITM20oYDaydGImw5b4Y9swoRUcPXhXgXee9UtSts4PW-iB3Mq7OihXk6IXU-eCtmFY8";
    REACT_APP_LANDLORD_DEMO_URL = "https://calendly.com/taj-sohal/30min";
    REACT_APP_TURNSTILE_SITE_KEY = "0x4AAAAAADxRAvYslYkNBy5F";
    break;
  default:
    // fallback for other envs if needed
    break;
}

export {
  BASE_URL,
  FETCHFIGFYURL,
  FETCHFYTOKEN,
  BUCKETNAME,
  REGION,
  REACT_APP_STRIPE_PUBLISHABLE_KEY,
  REACT_APP_FCM_VAPID_KEY,
  REACT_APP_LANDLORD_DEMO_URL,
  REACT_APP_TURNSTILE_SITE_KEY
};
